/* unplugin-vue-components disabled */import { render } from "./debug.vue?vue&type=template&id=2d6c1c2b&scoped=true"
import script from "./debug.vue?vue&type=script&lang=js"
export * from "./debug.vue?vue&type=script&lang=js"

import "./debug.vue?vue&type=style&index=0&id=2d6c1c2b&lang=css"
import "./debug.vue?vue&type=style&index=1&id=2d6c1c2b&scoped=true&lang=css"
import "./debug.vue?vue&type=style&index=2&id=2d6c1c2b&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6c1c2b"]])

export default __exports__